import {Component, forwardRef, Input, OnChanges} from '@angular/core';
import {FormArray, FormBuilder, FormControl, FormGroup, NG_VALIDATORS, NG_VALUE_ACCESSOR,
  Validators} from '@angular/forms';
import {SyncValidatorComponent} from '../utils/base.component';
import {EinzelBuchung} from '../app/types';
import {FirebaseService} from '../app/firebase.service';
import {GruppenBuchung} from "./buchung";

@Component({
  selector: 'app-buchung-optionen',
  templateUrl: './buchung-optionen.component.html',
  styles: [],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => BuchungOptionenComponent)
    },
    {
      provide: NG_VALIDATORS,
      multi: true,
      useExisting: forwardRef(() => BuchungOptionenComponent)
    }
  ]
})
export class BuchungOptionenComponent extends SyncValidatorComponent implements OnChanges {
  formGroup: FormGroup;

  @Input() buchung: GruppenBuchung;

  constructor(public service: FirebaseService, private fb: FormBuilder) {
    super();
    this.formGroup = this.fb.group({
      reisen: new FormArray([])
    });
    this.formGroup.valueChanges.subscribe(value => {
      this.form2buchung();
      this.triggerValidation();
    });
  }

  ngOnChanges() {
    if (this.buchung) {
      this.buchung.buchungsListeChanged.subscribe(() => this.buchung2form());
    }
  }

  validate(c: FormControl) {
    const err = {
      requiredError: {
        r: 'required!'
      }
    };
    return this.buchung.valid ? null : err;
  }

  get reisenFormArray(): FormArray {
    return this.formGroup.get('reisen') as FormArray;
  }

  get kursSelected(): boolean {
    const formModel = this.formGroup.value;
    return formModel.reisen.some(reiseModel => {
      return reiseModel.buchungen.some(buchungModel =>
        buchungModel.selected && buchungModel.kurs != null
      );
    });
  }

  private buchung2form() {
    const reisenFormArray = new FormArray([]);
    if (!this.buchung || !this.buchung.reisen.length || !this.buchung.alleTeilnehmer.length) {
      this.formGroup.setControl('reisen', reisenFormArray);
      return;
    }
    this.buchung.reisen.forEach(reise => {
      const buchungenFormArray = new FormArray([]);
      this.buchung.alleTeilnehmer.forEach(teilnehmer => {
        const eb: EinzelBuchung = this.buchung.get(reise, teilnehmer);
        const formGroup = new FormGroup({
          eb: new FormControl(eb),
          reise: new FormControl(reise),
          teilnehmer: new FormControl(teilnehmer),
          selected: new FormControl({value: eb.selected, disabled: eb.bereitsGebucht})
        });
        if (reise.zustiege) {
          formGroup.addControl('zustieg',
            new FormControl(eb.zustieg, Validators.required));
        }
        if (reise.kategorien) {
          formGroup.addControl('kategorie',
            new FormControl(eb.kategorie, Validators.required));
        }
        if (reise.kurse) {
          formGroup.addControl('kurs', new FormControl(eb.kurs));
        }
        if (reise.dateBegin.getTime() !== reise.dateEnd.getTime()) {
          formGroup.addControl('zimmerwunsch', new FormControl(eb.zimmerwunsch));
        }
        if (reise.kurtaxe) {
          formGroup.addControl('kurtaxeCheckbox', new FormControl(eb.kurtaxe > 0));
        }
        if (reise.sorgenfreiTarif) {
          formGroup.addControl('sorgenfreiTarifCheckbox', new FormControl(eb.sorgenfreiTarif > 0));
        }
        formGroup.markAsPending();
        buchungenFormArray.push(formGroup);
      });
      reisenFormArray.push(new FormGroup({
        reiseLabel: new FormControl(reise.name),
        reise: new FormControl(reise),
        buchungen: buchungenFormArray
      }));
    });
    this.formGroup.setControl('reisen', reisenFormArray);
  }

  private form2buchung() {
    const formModel = this.formGroup.value;
    formModel.reisen.forEach(reiseModel => {
      reiseModel.buchungen.forEach(buchungModel => {
        buchungModel.kurtaxe = buchungModel.kurtaxeCheckbox ? reiseModel.reise.kurtaxe : null;
        buchungModel.sorgenfreiTarif = buchungModel.sorgenfreiTarifCheckbox ? reiseModel.reise.sorgenfreiTarif : null;
        this.buchung.set(buchungModel);
      });
    });
  }
}
